import APIServer from './APIServer'
import UtilsManager from '../managers/UtilsManager'

export default class SectionAPI extends APIServer { 
	
	constructor() { 
		super()
		this.utilsManager = new UtilsManager()
	}

	async getSection(sectionId, {zoneSlug=null} = {}) { 
		return await super.get(`/v1/section/${sectionId}?zone=${zoneSlug}`);
	}

	async getSectionsV1(zone, {version=null, inclusion_kind=null, expansions="tag", page=null, sectionIds=null, startDate=null, endDate=null} ={}) { 
		var url = "/v1/sections"
		const params = []
		params.push({zone: zone});
		if (page) { 
			params.push({page: page})
		}

		if (inclusion_kind) { 
			params.push({inclusion_kind: inclusion_kind})
		}

		if (expansions) { 
			params.push({expansions: expansions})
		}

		if (page) { 
			params.push({page: page})
		}

		if (sectionIds) {
			params.push({section_ids: sectionIds})
		}

		if (startDate) {
			params.push({start_date: startDate})
		}

		if (endDate) { 
			params.push({end_date: endDate})
		}

		url += this.utilsManager.combineParamsV2(params);
		return await super.get(url)
	}

	async getSections(zone, version=null, inclusion_kind=null, expansions="tag", page=null, sectionIds=null) { 
		var url = "/sections"
		if (page) { 
			url = "/v1/sections"
		}

		const params = []
		
		if (zone !== null && zone !== undefined) { 
			params.push({
				title: 'zone',
				value: zone
			})
		}

		if (page) { 
			params.push({title: "page", value: page})
		}

		if (version !== null) {
			params.push({
				title: 'version',
				value: version
			})
		}

		if (inclusion_kind) { 
			params.push({
				title: 'inclusion_kind',
				value: inclusion_kind
			});
		}
		if (expansions) { 
			params.push({
				title: 'expansions',
				value: expansions
			});
		}
		if (sectionIds) { 
			params.push({
				title: 'section_ids', 
				value: sectionIds.toString()
			})
		}

		url += this.utilsManager.combineParams(params)
		return await super.get(url)
	}
}